import { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import popupMainActions from "../../modules/popupMainActions";
import { validatePhoneNumber } from "../../../utils/validation";

export const usePopup = (initialLanguage) => {
  const [visible, setVisible] = useState(true);
  const [popupData, setPopupData] = useState(null);
  const [sentNumber, setSentNumber] = useState(false);
  const [parentURL, setParentURL] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [disable, setDisable] = useState(true);

  const { token: locationId } = useParams();
  const location = useLocation();

  const loadPopupData = async () => {
    if (!locationId) return;

    const result = await popupMainActions.getPopup(locationId);
    if (result.success) {
      setPopupData(result.data);
    } else {
      setVisible(false);
    }
  };

  const loadParentURL = () => {
    const params = new URLSearchParams(location.search);
    const urlValue = params.get("url");

    if (!urlValue) return;

    const newUrl = location.hash ? `${urlValue}${location.hash}` : urlValue;

    setParentURL(newUrl);
  };

  const handlePhoneChange = (value) => {
    setDisable(true);
    setPhoneNumber(value);
    const validPhone = validatePhoneNumber(value);
    setDisable(!validPhone);
  };

  const handlePhoneNumberPaste = (event, countryCode) => {
    setDisable(true);

    let pasteValue = (event.clipboardData || window.clipboardData)
      .getData("text")
      .replace(/[-\s()tel:+]/g, "");

    const isAustralian = countryCode?.toLowerCase() === "au";

    if (isAustralian) {
      if (pasteValue.length === 9) {
        pasteValue = `61${pasteValue}`;
      } else if (pasteValue.length >= 11) {
        pasteValue = `61${pasteValue.slice(2)}`;
      }
    } else {
      if (pasteValue.length === 10) {
        pasteValue = `1${pasteValue}`;
      } else if (pasteValue.length === 11) {
        pasteValue = `1${pasteValue.slice(1)}`;
      }
    }

    const validPhone = validatePhoneNumber(pasteValue);
    setDisable(!validPhone);
    setPhoneNumber(pasteValue);
  };

  const close = () => {
    window.top.postMessage("matador_coupon_message_hidden", "*");
    setVisible(false);
  };

  return {
    visible,
    popupData,
    sentNumber,
    parentURL,
    phoneNumber,
    disable,
    setSentNumber,
    handlePhoneChange,
    handlePhoneNumberPaste,
    close,
    loadPopupData,
    loadParentURL,
  };
};
